import { MenuItem, TextField, TextFieldProps } from "@material-ui/core";
import React, { FC } from "react";

export interface SelectOption {
    value: string | number;
    label: string;
}

export interface CustomSelectProps {
    options: SelectOption[];
}

const CustomSelect: FC<CustomSelectProps & TextFieldProps> = ({
    options,
    ...restProps
}) => {
    return (
        <TextField
            margin="dense"
            fullWidth
            variant="outlined"
            {...restProps}
            select
        >
            {options.map(({ value, label }) => (
                <MenuItem key={value} value={value}>
                    {label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default CustomSelect;
